var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader, ModalFooter, Label, Input, } from 'reactstrap';
import OtoError from './common/OtoError';
import CalendarAlt from '../icons/CalendarAlt';
import Clock from '../icons/Clock';
import UserFriends from '../icons/UserFriends';
import Utensils from '../icons/Utensils';
import { mapReservationFormValuesToDTO, createReservation, } from '../utils/reservation';
import { getSelectedDateLabel } from '../app/date-helpers';
import { NO_ADDITIONAL_NOTES_GUARANTEE } from '../app/lang';
import { getBookingRestrictionsForDate, formatBookingRestrictionAlert, } from '../app/logic';
import { hasKids, hasAreaPreferencePossibility, getBookingConfig, } from '../app/general';
import { createDerivedStateFromErrorLogger, logComponentDidCatch, } from '../utils/log';
import Restaurant from '../utils/restaurant';
import { getPeopleAmountLabel } from '../utils/text-formatters';
import OtoSpinner from './common/OtoSpinner';
import ReservationRestaurantClosedAlert from './ReservationRestaurantClosedAlert';
import { AnalyticsService } from 'Utils/tracking';
import OtoAlertNew from './common/OtoAlertNew';
import { isDesktop } from 'App/app/ui';
import Shapes from 'Shapes';
var areaPreferenceOptions = [
    { key: '', label: 'brak preferencji' },
    { key: 'outside', label: 'ogródek' },
    { key: 'inside', label: 'wnętrze' },
];
var reservationDurationOptions = [
    { label: '1h', value: 60 },
    { label: '1.5h', value: 90 },
    { label: '2h', value: 120 },
    { label: '2.5h', value: 150 },
    { label: '3h', value: 180 },
    { label: '4h', value: 240 },
    { label: '5h', value: 300 },
    { label: 'Do końca dnia', value: 720 },
];
var COMPONENT_NAME = 'ReservationModal';
var ReservationModal = /** @class */ (function (_super) {
    __extends(ReservationModal, _super);
    function ReservationModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            bookingTimeExplanationVisible: false,
            loading: false,
            hasError: false,
            validationErrors: {},
            errorMessage: '',
            values: {
                customer_fn: '',
                customer_ln: '',
                customer_phone: '',
                notes_from_guest: '',
                kids_number: '0',
            },
        };
        _this.bookingWaitingTimes = {
            instant: 'natychmiast',
            couple_of_hours: 'do kilku godzin',
            twice_per_day: 'do 1 dnia',
        };
        _this.getBookingWaitingTime = function (restaurant) {
            return (_this.bookingWaitingTimes[restaurant.booking_waiting_time] ||
                restaurant.booking_waiting_time);
        };
        _this.showBookingTimeExplanation = function () {
            return _this.setState({ bookingTimeExplanationVisible: true });
        };
        _this.handleChange = function (e) {
            var _a, _b;
            if (e.target.type === 'checkbox') {
                return _this.setState({
                    values: __assign(__assign({}, _this.state.values), (_a = {}, _a[e.target.name] = e.target.checked, _a)),
                });
                return;
            }
            _this.setState({
                values: __assign(__assign({}, _this.state.values), (_b = {}, _b[e.target.name] = e.target.value, _b)),
            });
        };
        _this.renderWaitingTimeAlert = function () { return (React.createElement(OtoAlertNew, { className: "m-2", color: "info", withBorder: true }, "Czas oczekiwania na potwierdzenie rezerwacji zale\u017Cy od warunk\u00F3w wsp\u00F3\u0142pracy z restauracj\u0105. Wp\u0142yw na d\u0142ugo\u015B\u0107 procesu ma mi\u0119dzy innymi wykorzystanie naszego systemu do przyjmowania rezerwacji (natychmiastowe potwierdzenie) lub rezygnacja z niego (potwierdzenie po kontakcie telefonicznym z lokalem). Robimy, co w naszej mocy, aby maksymalnie skr\u00F3ci\u0107 Pa\u0144stwa oczekiwanie na potwierdzenie.")); };
        _this.handleSubmit = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var form, isValid, reservationData, result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        form = document.getElementById('reservationModalForm');
                        isValid = form.checkValidity();
                        form === null || form === void 0 ? void 0 : form.classList.add('was-validated');
                        if (!isValid) {
                            return [2 /*return*/];
                        }
                        // Clear previous errors
                        this.setState({
                            loading: true,
                            hasError: false,
                            validationErrors: {},
                            errorMessage: ''
                        });
                        reservationData = mapReservationFormValuesToDTO(__assign(__assign({}, this.state.values), { restaurantId: this.props.restaurant.id, visitDate: this.props.visitDate, visitTime: this.props.visitTime, peopleAmount: this.props.peopleAmount, source: this.props.source }));
                        AnalyticsService.trackBookingPurchase();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, createReservation(reservationData)];
                    case 2:
                        result = _a.sent();
                        if (!result.success && result.error) {
                            if (result.error.type === 'validation') {
                                this.setState({
                                    loading: false,
                                    validationErrors: result.error.errors || {},
                                    errorMessage: result.error.message || 'Proszę sprawdzić pola formularza'
                                });
                            }
                            else {
                                this.setState({
                                    loading: false,
                                    hasError: true,
                                    errorMessage: result.error.message || 'Wystąpił błąd podczas tworzenia rezerwacji'
                                });
                            }
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.setState({
                            loading: false,
                            hasError: true,
                            errorMessage: 'Wystąpił nieoczekiwany błąd'
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ReservationModal.prototype.componentDidCatch = function (error, info) {
        logComponentDidCatch(COMPONENT_NAME, error, info);
    };
    ReservationModal.prototype.renderDetails = function () {
        var _a = this.props, explainConfirmationDuration = _a.explainConfirmationDuration, peopleAmount = _a.peopleAmount, visitTime = _a.visitTime, visitDate = _a.visitDate, restaurant = _a.restaurant;
        var bookingTimeExplanationVisible = this.state.bookingTimeExplanationVisible;
        var _b = getSelectedDateLabel(visitDate), date = _b.date, label = _b.label;
        var has_kids = hasKids(restaurant);
        var details = (React.createElement("div", { className: "reserve-modal__details" },
            React.createElement("div", null,
                React.createElement(CalendarAlt, null),
                "Data: ",
                date,
                ' ',
                React.createElement("span", { className: "reserve-modal__details-date-label" }, label)),
            React.createElement("div", null,
                React.createElement(Clock, null),
                "Godzina: ",
                visitTime),
            React.createElement("div", null,
                React.createElement(UserFriends, null),
                "Stolik dla:",
                ' ',
                getPeopleAmountLabel(peopleAmount, {
                    has_kids: has_kids,
                    kids_number: parseInt(this.state.values.kids_number || '0', 10),
                })),
            React.createElement("div", null,
                React.createElement(Utensils, null),
                "Lokal: ",
                restaurant.name),
            React.createElement("div", null,
                React.createElement("span", { className: "mr-1" },
                    React.createElement(Clock, null),
                    "Otrzymasz potwierdzenie:",
                    ' ',
                    React.createElement("span", { className: "text-primary" }, this.getBookingWaitingTime(restaurant)))),
            bookingTimeExplanationVisible &&
                !isDesktop() &&
                this.renderWaitingTimeAlert(),
            !bookingTimeExplanationVisible && explainConfirmationDuration && (React.createElement("button", { className: "btn btn-custom-outlined", type: "button", onClick: this.showBookingTimeExplanation }, "od czego zale\u017Cy czas oczekiwania na rezerwacj\u0119?"))));
        return details;
    };
    ReservationModal.prototype.render = function () {
        var _this = this;
        var toggle = function () { return _this.props.hideModal(); };
        var form = document.getElementById('reservationModalForm');
        var showMarketingFields = this.props.showMarketingFields;
        return (React.createElement(Modal, { isOpen: true, toggle: toggle, className: "reserve-modal" },
            React.createElement("form", { className: "modal-content", id: "reservationModalForm", noValidate: true, onSubmit: this.handleSubmit },
                React.createElement(ModalHeader, { toggle: toggle }, "Dane rezerwacji"),
                React.createElement(ModalBody, { className: "row" },
                    React.createElement(ReservationRestaurantClosedAlert, { restaurant: this.props.restaurant }),
                    (function () {
                        var _a, _b;
                        var _c = _this.props, restaurant = _c.restaurant, visitDate = _c.visitDate;
                        var restrictions = getBookingRestrictionsForDate(restaurant, visitDate);
                        var restrictionMessage = (((_a = restrictions.allowedHours) === null || _a === void 0 ? void 0 : _a.length) ||
                            ((_b = restrictions.allowedGuests) === null || _b === void 0 ? void 0 : _b.length)) &&
                            formatBookingRestrictionAlert(visitDate, restrictions.allowedHours, restrictions.allowedGuests);
                        return restrictionMessage ? (React.createElement(OtoAlertNew, { color: "info", className: "mb-3", withBorder: true }, restrictionMessage)) : null;
                    })(),
                    React.createElement("div", { className: "reserve-modal__part reserve-modal__part--details" }, this.renderDetails()),
                    this.renderInputsPart(),
                    this.state.bookingTimeExplanationVisible &&
                        isDesktop() &&
                        this.renderWaitingTimeAlert()),
                React.createElement(ModalFooter, null,
                    React.createElement("div", { className: "form-check w-100 mb-2" },
                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "terms-of-use", required: true }),
                        React.createElement("label", { className: "form-check-label", htmlFor: "terms-of-use" },
                            "Zapozna\u0142em si\u0119 i akceptuj\u0119",
                            ' ',
                            React.createElement("a", { href: "/regulamin", target: "_blank" }, "regulamin"),
                            ' ',
                            "oraz",
                            ' ',
                            React.createElement("a", { href: "/polityka-prywatnosci", target: "_blank" }, "polityk\u0119 prywatno\u015Bci"))),
                    showMarketingFields && (React.createElement(React.Fragment, null,
                        React.createElement("div", null,
                            "Chcesz otrzymywa\u0107 informacje o",
                            ' ',
                            React.createElement("span", { className: "text-primary" }, "promocjach oraz nowo\u015Bciach"),
                            ' ',
                            "w tym lokalu?",
                            React.createElement("br", null),
                            "Wyra\u017Cam zgod\u0119 na otrzymywanie informacji marketingowych:"),
                        React.createElement("div", { className: "form-check w-100" },
                            React.createElement("input", { className: "form-check-input", id: "sms_marketing", name: "sms_marketing", onChange: this.handleChange, type: "checkbox" }),
                            React.createElement("label", { className: "form-check-label", htmlFor: "sms_marketing" }, "za po\u015Brednictwem SMS")),
                        React.createElement("div", { className: "form-check w-100" },
                            React.createElement("input", { className: "form-check-input", id: "email_marketing", name: "email_marketing", onChange: this.handleChange, type: "checkbox" }),
                            React.createElement("label", { className: "form-check-label", htmlFor: "email_marketing" }, "za po\u015Brednictwem email")))),
                    this.renderFooterActions()))));
    };
    ReservationModal.prototype.renderInputsPart = function () {
        var _a = this.props, restaurant = _a.restaurant, peopleAmount = _a.peopleAmount, showEmailField = _a.showEmailField;
        var hasOutsideBookPossibility = hasAreaPreferencePossibility(restaurant);
        var bookingConfig = getBookingConfig(restaurant) || {
            reservation_duration_options: false,
        };
        var guestDurations = bookingConfig.reservation_duration_options_for_guests, restaurantDurations = bookingConfig.reservation_duration_options;
        var durationOptions = (guestDurations === null || guestDurations === void 0 ? void 0 : guestDurations.length)
            ? guestDurations
            : restaurantDurations || [];
        return (React.createElement("div", { className: "reserve-modal__part reserve-modal__part--inputs" },
            React.createElement("input", { onChange: this.handleChange, id: "customer_fn", type: "text", name: "customer_fn", placeholder: "Imi\u0119", required: true }),
            React.createElement("div", { className: "invalid-feedback" }, "Zapoznajmy si\u0119 :)"),
            React.createElement("input", { onChange: this.handleChange, id: "customer_ln", type: "text", name: "customer_ln", placeholder: "Nazwisko", required: true }),
            React.createElement("div", { className: "invalid-feedback" }, "Cz\u0119\u015B\u0107 lokali pozwala na rezerwacj\u0119 wy\u0142\u0105cznie na nazwisko"),
            React.createElement("input", { onChange: this.handleChange, id: "customer_phone", name: "customer_phone", type: "tel", placeholder: "Telefon", required: true, pattern: "([0-9]{9})|([0-9]{3} [0-9]{3} [0-9]{3})|([0-9]{3}-[0-9]{3}-[0-9]{3})|(\\+\\d{11})|(\\+\\d{2}-\\d{3}-\\d{3}-\\d{3})|(\\+\\d{2} \\d{3} \\d{3} \\d{3})" }),
            React.createElement("div", { className: "invalid-feedback" }, "Podaj prosz\u0119 numer telefonu, aby\u015Bmy mogli potwierdzi\u0107 rezerwacj\u0119, lub poinformowa\u0107 Ci\u0119, je\u015Bli co\u015B p\u00F3jdzie nie tak"),
            showEmailField && (React.createElement(React.Fragment, null,
                React.createElement("input", { onChange: this.handleChange, id: "customer_email", name: "customer_email", type: "email", placeholder: "Email", required: true }),
                React.createElement("div", { className: "invalid-feedback" }, "Restauracja wymaga podania adresu email w celu dokonania rezerwacji"))),
            React.createElement("div", { className: "reserve-modal__disclaimer" }, "*Nie przekazujemy danych osobom trzecim, s\u0105 one potrzebne wy\u0142\u0105cznie do potwierdzenia rezerwacji."),
            hasKids(restaurant) ? (React.createElement("input", { onChange: this.handleChange, type: "number", id: "kids_number", name: "kids_number", placeholder: "Liczba dzieci siedz\u0105cych", className: "form-control mb-2", min: "0", max: peopleAmount })) : null,
            Restaurant.wantsToCountNonVaccinated(restaurant) && (React.createElement(React.Fragment, null,
                React.createElement(Label, { for: "non_vaccinated_amount" }, "Liczba os\u00F3b niezaszczepionych"),
                React.createElement(Input, { onChange: this.handleChange, type: "select", id: "non_vaccinated_amount", name: "non_vaccinated_amount", placeholder: "Liczba os\u00F3b niezaszczepionych", className: "form-control mb-2", required: true, min: "0", max: peopleAmount },
                    React.createElement("option", { key: "", value: "" }),
                    React.createElement("option", { key: "0", value: 0 }, "wszyscy s\u0105 zaszczepieni"),
                    Array.from(Array(peopleAmount)).map(function (_, num) { return (React.createElement("option", { key: num + 1, value: num + 1 }, num + 1)); })),
                React.createElement("div", { className: "invalid-feedback" }, "Podaj prosz\u0119 liczb\u0119 os\u00F3b niezaszczepionych"))),
            hasOutsideBookPossibility && (React.createElement(React.Fragment, null,
                React.createElement("label", { htmlFor: "area_preferences", className: "mb-0" }, "Ogr\u00F3dek czy wn\u0119trze?"),
                React.createElement("select", { id: "area_preferences", name: "area_preferences", onChange: this.handleChange, className: "form-control mb-3" }, areaPreferenceOptions.map(function (opt) { return (React.createElement("option", { key: opt.key, value: opt.key }, opt.label)); })))),
            !!durationOptions.length && (React.createElement(React.Fragment, null,
                React.createElement("label", { htmlFor: "duration", className: "mb-0" }, "D\u0142ugo\u015B\u0107 rezerwacji"),
                React.createElement("select", { id: "duration", name: "duration", onChange: this.handleChange, className: "form-control mb-3" }, durationOptions.map(function (opt) {
                    var _a;
                    return (React.createElement("option", { key: opt, value: opt }, (_a = reservationDurationOptions.find(function (o) { return o.value === opt; })) === null || _a === void 0 ? void 0 : _a.label));
                })))),
            React.createElement("textarea", { onChange: this.handleChange, className: "form-control", id: "notes_from_guest", name: "notes_from_guest", placeholder: "Dodatkowe uwagi dla restauracji" }),
            this.state.values.notes_from_guest && (React.createElement("div", { className: "alert alert-warning small w-100 m-0 mt-2" }, NO_ADDITIONAL_NOTES_GUARANTEE))));
    };
    ReservationModal.prototype.getFieldLabel = function (fieldName) {
        var fieldLabels = {
            'name': 'Imię i nazwisko',
            'phone': 'Numer telefonu',
            'email': 'Adres e-mail',
            'restaurantId': 'Restauracja',
            'reserved_on': 'Data i godzina rezerwacji',
            'guests_number': 'Liczba gości',
            'source': 'Źródło',
            'notes_from_guest': 'Uwagi',
            'duration': 'Czas trwania',
            'tables': 'Stoliki',
            'customer_name': 'Imię i nazwisko',
            'phone_number': 'Numer telefonu',
            'restaurant_id': 'Restauracja'
        };
        return fieldLabels[fieldName] || fieldName;
    };
    ReservationModal.prototype.renderFooterActions = function () {
        var _this = this;
        var _a = this.state, hasError = _a.hasError, loading = _a.loading, validationErrors = _a.validationErrors, errorMessage = _a.errorMessage;
        if (hasError) {
            return (React.createElement(OtoError, null, errorMessage && React.createElement("p", null, errorMessage)));
        }
        if (Object.keys(validationErrors).length > 0) {
            return (React.createElement("div", { className: "alert alert-danger" },
                React.createElement("p", null,
                    React.createElement("strong", null, "Prosz\u0119 poprawi\u0107 nast\u0119puj\u0105ce b\u0142\u0119dy:")),
                React.createElement("ul", { className: "mb-0" }, Object.entries(validationErrors).map(function (_a) {
                    var _b = __read(_a, 2), field = _b[0], errors = _b[1];
                    return (React.createElement("li", { key: field },
                        React.createElement("strong", null,
                            _this.getFieldLabel(field),
                            ":"),
                        " ",
                        Array.isArray(errors) ? errors.join(', ') : String(errors)));
                })),
                errorMessage && React.createElement("p", { className: "mt-2 mb-0" }, errorMessage)));
        }
        return loading ? (React.createElement(OtoSpinner, null)) : (React.createElement("button", { type: "submit", className: "btn btn-primary", id: "reservationModalButton" }, "Zarezerwuj"));
    };
    ReservationModal.displayName = COMPONENT_NAME;
    ReservationModal.getDerivedStateFromError = createDerivedStateFromErrorLogger(COMPONENT_NAME);
    ReservationModal.propTypes = {
        hideModal: PropTypes.func.isRequired,
        peopleAmount: PropTypes.number.isRequired,
        restaurant: Shapes.restaurantShape.isRequired,
        source: PropTypes.string.isRequired,
        visitTime: PropTypes.string.isRequired,
        visitDate: PropTypes.instanceOf(Date).isRequired,
    };
    return ReservationModal;
}(React.PureComponent));
export default ReservationModal;
